<template>
  <div id="app">

    <!-- 头部组件 -->
    <NavHeader v-if="isRouterAlive"/>

    <!-- 路由组件 -->
    <router-view></router-view>

    <!-- 底部组件 -->
    <NavFooter/>
  </div>
</template>

<script>
// 引入组件
import NavHeader from '@/components/NavHeader.vue'
import NavFooter from '@/components/NavFooter.vue'

import '@/assets/css/app.css'
import '@/assets/css/font.css'

export default {
  name: 'app',
  components: {
    NavHeader,
    NavFooter
  },
  provide() {
        return {
            reloadAll: this.reloadAll,
        }
  },
  data(){
    return {
      // 控制组件是否展示
      isRouterAlive:true
    }
  },
  methods: {
    // 刷新组件
    reloadAll() {
        this.isRouterAlive = false
        this.$nextTick(() => {
            this.isRouterAlive = true
        })
     }
  }
}
</script>

<style scoped>
  #app{
    overflow: hidden;
  }
</style>
